<section class="breadcrumb-banner">
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-lg-12">
                <div class="breadcrumb-text">
                    <h1>
                        Nagpur District 1st Selection Badminton Tournament
                    </h1>
                </div>
            </div>
        </div>
    </div>
    <div class="breadcrumb-bottom-img">
        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png">
    </div>
</section>
<section class="section section-sm fide-chesscompetition section-banner-bg-1">
    <div class="container">
        <div class="sec-title text-center mb-5">
            <h2><span> Nagpur District 1st Selection Badminton Tournament 2025</span></h2>
        </div>
        <div class="row justify-content-between">
            <div class="col-md-12">
                <p>
                    <strong>Event Dates:</strong> 1st May 2025 – 3th May 2025
                </p>
                <p>
                    <strong>Venue:</strong> Subhedar Badminton Hall, RTMNU Campus, Ravi Nagar, Nagpur – 440010
                </p>
                <p>
                    <strong>Organized by:</strong> Nagpur District Badminton Association (NDBA)
                </p>
                <p>
                    <strong>Total Prize Pool:</strong> ₹2,04,000
                </p>
                <p>
                    <strong>Overview</strong>
                </p>
                <p>The Nagpur District 1st Selection Badminton Tournament 2025 concluded successfully on 3th May 2025,
                    after four days of intense competition and spectacular display of talent. Hosted at the
                    state-of-the-art Subhedar Badminton Hall within the RTMNU Campus, the tournament witnessed
                    enthusiastic participation from budding and seasoned shuttlers across various age categories,
                    serving as the first official district-level selection event of the year.</p>

                <p>This prestigious tournament, organized by the Nagpur District Badminton Association (NDBA), was an
                    important stepping stone for players aiming for higher-level state and national competitions. With a
                    total prize pool of ₹2,04,000, the event attracted over 300 participants from across Nagpur
                    district.</p>

                <h6>Event Highlights</h6>
                <ul class="list-style list-style1  mb-3 ">
                    <li><strong> Date:</strong> 1st May 2025 to 4th May 2025</li>

                    <li><strong>Total Matches Played:</strong> 235+</li>

                    <li><strong>Participants: </strong> 300+ players across multiple categories</li>
                </ul>
                <h6>Categories:</h6>

                <ul class="list-style list-style1 list-count  mb-3 ">
                    <li> Under 11 Boys & Girls</li>

                    <li>Under 13 Boys & Girls</li>

                    <li>Under 15 Boys & Girls</li>

                    <li>Under 17 Boys & Girls</li>

                    <li>Under 19 Boys & Girls</li>

                    <li>Men's & Women's Singles</li>

                    <li>Doubles & Mixed Doubles</li>
                </ul>
                <p> <strong>Court Setup: </strong>4 synthetic courts</p>

                <p><strong>Live Scoring & Digital Display:</strong> Enabled for major matches</p>

                <p><strong>Audience:</strong> Over 1,500 attendees including parents, coaches, and sports enthusiasts
                </p>
            </div>
            <div class="col-md-12">
                <div class="lightBox--gallery">
                    <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ngpr-dist-1st-selection-badminton1.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ngpr-dist-1st-selection-badminton1.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ngpr-dist-1st-selection-badminton1.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ngpr-dist-1st-selection-badminton2.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ngpr-dist-1st-selection-badminton2.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ngpr-dist-1st-selection-badminton2.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ngpr-dist-1st-selection-badminton3.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ngpr-dist-1st-selection-badminton3.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ngpr-dist-1st-selection-badminton3.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>

                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ngpr-dist-1st-selection-badminton4.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ngpr-dist-1st-selection-badminton4.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ngpr-dist-1st-selection-badminton4.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ngpr-dist-1st-selection-badminton5.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ngpr-dist-1st-selection-badminton5.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ngpr-dist-1st-selection-badminton5.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ngpr-dist-1st-selection-badminton6.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ngpr-dist-1st-selection-badminton6.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ngpr-dist-1st-selection-badminton6.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ngpr-dist-1st-selection-badminton7.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ngpr-dist-1st-selection-badminton7.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ngpr-dist-1st-selection-badminton7.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>

                    </ul>
                </div>

            </div>
        </div>
    </div>
</section>
